<template>
  <div v-loading="loading">
    <div class="pagemain">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px" label-position="left">
        <div class="form-group">
          <div class="form-group-content">
            <div class="mm-row-block">
              <div class="form-isheader-group">
                <div class="group-title">
                  <h3>交易信息</h3>
                </div>
                <div class="form-isheader-group-content">
                  <div class="box-group" style="padding-bottom: 0;">
                    <div class="mm-row ">
                      <div class="mm-item">
                        <el-form-item label="建立部門">
                          <el-select class="elselect" v-model="form.sector_id" placeholder="請選擇">
                            <el-option :label="'未選擇'" :value="0"></el-option>
                            <template v-for="item in sectorlist">
                              <el-option :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </template>
                          </el-select>
                        </el-form-item>
                      </div>
                    </div>
                    <div class="mm-row ">
                      <div class="mm-item">
                        <el-form-item label="所屬門店" required>
                          <el-select class="elselect" @change="getcurrency()" v-model="form.store_id" placeholder="請選擇">
                            <template v-for="item in storelist">
                              <el-option :key="item.id" :label="item.short+' '+item.name" :value="item.id"></el-option>
                            </template>
                          </el-select>
                        </el-form-item>

                      </div>
                    </div>
                    <div class="mm-row">
                      <div class="mm-item">
                        <el-form-item label="業務類型" required>
                          <el-radio-group v-model="form.type" @input="getcurrency">
                            <el-radio-button label="0">兌換</el-radio-button>
                            <el-radio-button label="1">匯款</el-radio-button>
                            <el-radio-button label="2">內部記賬</el-radio-button>
                          </el-radio-group>
                        </el-form-item>
                      </div>
                    </div>
                    <div class="mm-row">
                      <div class="mm-item">
                        <el-form-item label="交易編號">
                          <div>B{{showdata.businessnum}}</div>
                        </el-form-item>
                      </div>
                    </div>
                    <div class="mm-row">
                      <div class="mm-item">
                        <el-form-item label="關聯訂單">
                          <div v-if="showdata.order_id>0">
                            <span v-if="showdata.ordertype == 0">{{showdata.store_short}}-C{{showdata.ordernum}}</span>
                            <span v-if="showdata.ordertype == 1">{{showdata.store_short}}-R{{showdata.ordernum}}</span>
                            <span v-if="showdata.ordertype == 2">{{showdata.store_short}}-I{{showdata.ordernum}}</span>
                          </div>
                        </el-form-item>
                      </div>
                    </div>
                  </div>
                  <div class="box-group backgroup">
                    <div class="mm-row">
                      <div class="mm-item">
                        <el-form-item class="buyaofloat" label="交易方式" required>
                          <div>
                            <el-radio-group v-model="form.mode" @change="getcurrency">
                              <el-radio-button label="0">現金</el-radio-button>
                              <el-radio-button v-if="form.type == 1" label="1">銀行轉賬</el-radio-button>
                              <el-radio-button v-if="form.type == 1" label="2">特別賬戶</el-radio-button>

                            </el-radio-group>
                          </div>
                        </el-form-item>
                      </div>
                    </div>

                    <div class="mm-row">
                      <div class="mm-item">
                        <el-form-item class="buyaofloat" label="交易金額" required>
                          <div class="mm-flex">
                            <div class="mm-flex-item">
                              <el-select v-model="form.currency_id" @change="getrate" placeholder="請選擇">
                                <el-option v-for="(item,index) in currency" :key="index" :label="item.short_name+' '+item.name" :value="item.currency_id"></el-option>
                              </el-select>
                            </div>
                            <div class="mm-flex-item">
                              <el-input type="text" v-model.number="form.money" clearable></el-input>
                            </div>
                          </div>
                        </el-form-item>
                      </div>
                    </div>
                    <div class="mm-row">
                      <div class="mm-item">
                        <el-form-item label="交易賬號" required>
                          <div class="zhinput">
                            <el-select class="elselect" v-model="form.account_id" placeholder="請選擇">
                              <el-option v-if="form.mode==1" :label="'未選擇'" value="0"></el-option>
                              <template v-for="(item,index) in account">
                                <el-option v-if="form.mode==0" :key="index" :label="'[現金]'+item.storename+'--餘額：'+item.short_name+' '+item.money" :value="item.store_id">
                                </el-option>
                                <el-option v-if="form.mode==1" :key="index" :label="item.account_name+'--'+item.bankname+'--'+addSpace(item.account_num)+'--餘額：'+item.balance+' '+item.currency_short_name" :value="item.id">
                                </el-option>
                                <el-option v-if="form.mode==2" :key="index" label="" value="">
                                </el-option>
                              </template>
                            </el-select>
                          </div>
                        </el-form-item>
                      </div>
                    </div>

                    <div class="mm-row">
                      <div class="mm-item">
                        <el-form-item class="zhehe" label="折合港幣" required>
                          <div class="mm-flex phoneflex">
                            <div class="mm-flex-item">
                              <el-input disabled v-model="form.hkd"></el-input>
                            </div>
                            <div class="mm-flex-item" style="display:flex;">
                              @<span class="mr15" v-show="!editrate">{{form.rate}}</span>
                              <el-input style="width:80px;"   v-model="form.rate" v-show="editrate" class="mr15" clearable></el-input>
                              <el-button @click="editrate=!editrate;" type="primary">
                                <span v-show="!editrate">修改匯率</span>
                                <span v-show="editrate">保存匯率</span>
                              </el-button>
                            </div>
                          </div>
                        </el-form-item>
                      </div>
                    </div>
                    <div class="mm-row">
                      <div class="mm-item">
                        <el-form-item label="成本匯率" required>
                          <div>
                            <div>
                              <span class="mr15" v-show="!editcostrate">{{form.costrate}}</span>
                              <el-input v-model="form.costrate" v-show="editcostrate" class="mr15"></el-input>
                              <!-- <el-button @click="editcostrate=!editcostrate;" type="primary">
                                <span v-show="!editcostrate">修改成本匯率</span>
                                <span v-show="editcostrate">保存成本匯率</span>
                              </el-button> -->
                            </div>
                          </div>
                        </el-form-item>
                      </div>

                    </div>

                  </div>
                  <div class="box-group">
                    <div class="mm-row">
                      <div class="mm-item">
                        <el-form-item label="交易類型" required>
                          <div>
                            <el-radio-group v-model="form.business_type">
                              <el-radio-button v-if="form.type == 0" label="0">兌換</el-radio-button>
                              <el-radio-button v-else-if="form.type == 1" label="0">匯款</el-radio-button>
                              <el-radio-button label="1">客戶結餘</el-radio-button>
                              <el-radio-button label="2">手續費收入</el-radio-button>
                              <el-radio-button label="4">運營資金</el-radio-button>
                            </el-radio-group>
                          </div>
                        </el-form-item>
                      </div>
                    </div>
                  </div>
                  <div class="form-group-content backgroup" v-if="false">
                  <!-- <div class="form-group-content backgroup" v-if="(form.type == 1||form.type == 2)&&(form.mode==1)"> -->
                    <div class="mm-row">
                      <div class="mm-col">
                        <div class="mm-item mb20">
                          <label class="mm-label">貨幣類型：</label>
                          <el-radio-group  v-model="form.area">
                            <el-radio-button label="0">港幣</el-radio-button>
                            <el-radio-button label="1">人民幣</el-radio-button>
                            <el-radio-button label="2">外幣</el-radio-button>
                          </el-radio-group>
                        </div>
                      </div>
                    </div>
                    <div v-if="form.area == 0">
                      <hkbanksinfo :data.sync="form.payee" />
                    </div>
                    <div v-if="form.area == 1">
                      <banksinfo :data.sync="form.payee" :reset="false" />
                    </div>
                    <div v-if="form.area == 2">
                      <overseasbanksinfo :data.sync="form.payee" />
                    </div>
                  </div>
                  <div class="box-group">
                    <div class="mm-row" style="margin-bottom: 30px;">
                      <div class="mm-item">
                        <el-form-item label="水單上傳">

                          <div>
                            <uploadimage :fileDir="'business'" :imageUrlList.sync="form.upload_list" :oldImageUrlList.sync="form.file_list" listType="picture-card"></uploadimage>
                          </div>
                        </el-form-item>
                      </div>
                    </div>
                    <div class="mm-row">
                      <div class="mm-item">
                        <el-form-item label="備註">
                          <div>
                            <el-input type="textarea" :rows="2" placeholder="請輸入內容" v-model="form.mark" clearable></el-input>
                          </div>
                        </el-form-item>
                      </div>
                    </div>
                    <div class="mm-row">
                      <div class="mm-item">
                        <el-form-item label="交易進度">
                          <div>
                            <el-select v-model="form.status" placeholder="請選擇">
                              <el-option v-for="item in status_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                          </div>
                        </el-form-item>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="form-submit">
          <el-button :disabled="loading" @click="formsubmit('form')" type="primary">提交</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import uploadimage from '@/components/Uploadimage.vue';
import banksinfo from "@/components/BanksForm.vue";
import hkbanksinfo from "@/components/HKBanksForm.vue";
import overseasbanksinfo from "@/components/OverseasBanksForm.vue";

function getFloat (number, n) {
  n = n ? parseInt(n) : 2;
  if (n <= 0) {
    return Math.round(number);
  }
  number = Math.round(number * Math.pow(10, n)) / Math.pow(10, n); //四舍五入
  number = Number(number).toFixed(n); //补足位数
  return number;
};
export default {
  components: {
    uploadimage,
    hkbanksinfo,
    banksinfo,
    overseasbanksinfo,
  },
  props: {
    order_id: {
      type: Number,
      default: 0
    },
    id: {
      type: Number,
      default: 0,
    },
    showdata: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      isinit: true,
      editrate: false,
      editcostrate: false,
      showpicurl: '',
      showpicbox: false,
      aa: '',
      files: [],
      loading: false,
      storelist: [],
      sectorlist: [],
      form: {
        id: 0,
        order_id: 0,
        businessnum: '',
        store_id: 0,
        sector_id: 0,
        account_id: '',
        currency_id: 1,
        business_type: 0,
        buytype: 0,
        type: 0,
        type3: 0,
        mode: 0,
        rate: 1,
        costrate: 1,
        money: "",
        hkd: "",
        mark: "",
        status: 0,
        file_list: [],
        upload_list: [], // 新上传文件列表
        area: 1,
        is_linker: 0,
        payee: {
          address: "", // 地址
          remark: "", // 銀行備註
          phone: "", // 電話
          id_card: "", // 身份証
          account_num: "", // 賬號
          account_num_format: "", // 賬號
          account_name: "", // 持卡人
          province_id: "", // 省份
          city_id: "", // 城市
          country_id: 0,
          countryname: '',
          branch_id: "", // 支行名稱
          branch_name: "", // 支行名稱自定義
          hkbank_id: 0,
          hkbankname: "",
          cnbank_id: 0,
          bankname: "",
          currency_id: "", // 貨幣id
          swift_code: "", // swift_code
          currencyInfo: {},
        }, //收款人信息
      },
      rules: {},
      currency: [],
      account: [],
      status_options: [
        {
          value: 0,
          label: '準備中 Pending'
        },
        {
          value: 1,
          label: '已審核 Approved'
        },
        {
          value: 2,
          label: '處理中 Processing'
        },
        {
          value: 3,
          label: '已完成 Successful'
        },
        {
          value: 4,
          label: '失敗 Fail'
        },
        {
          value: 5,
          label: '已刪除 Deleted'
        },
      ],
    };
  },
  methods: {
    getrate () {
      // 重置銀行賬號
      this.form.account_id = '';
      this.account = [];
      let currency_id = this.form.currency_id;
      let currency = this.currency;
      if (currency.length > 0) {
        currency.some(item => {
          if (item.currency_id == currency_id) {
            if (this.form.type == 2) {
              // 内部記賬時，匯率等於成本匯率
              this.form.rate = item.costrate;
              this.form.costrate = item.costrate;
            } else {
              this.form.rate = item.buyrate;
              this.form.costrate = item.costrate;
            }
            this.form.type3 = item.is_division;
          }
        })
      } else {
        this.form.rate = 1.00;
        this.form.costrate = 1.00;
        this.form.type3 = 0;
      }
      if (this.form.mode == 0) {
        this.getfounds();
      } else if (this.form.mode == 1) {
        this.getbankaccounts();
      }
    },
    // 獲取現金賬號
    getcurrency () {
      // 重置銀行賬號
      this.form.account_id = '';
      this.account = [];

      this.post('/api/business/currency', {
        type: 0,
        store_id: this.form.store_id,
      }).then((res) => {
        if (res.length > 0) {
          this.currency = res;
        } else {
          this.form.currency_id = '';
          this.currency = [];
          this.form.costrate = 1;
        }
      }).catch((err) => {
        console.log(err)
      }).then(() => {
        this.getrate();
      })
    },
    getfounds () {
      // 重置銀行賬號
      let mode = this.form.mode;
      let currency_id = this.form.currency_id;
      let mso_id = sessionStorage.getItem('mso_id');
      this.post('/api/business/getfounds', {
        currency_id,
        mso_id,
        mode
      })
        .then(response => {
          if (response.length > 0) {
            this.account = response.filter(item => {
              if (item.store_id == this.form.store_id) {
                this.form.account_id = this.form.store_id;
                return true;
              }
            })
          } else {
            this.account = [];
          }
        }).catch(error => {
          console.log(error);
        });
    },
    getbankaccounts () {
      // 重置銀行賬號
      let currency_id = this.form.currency_id;
      this.post('/api/business/getbankaccounts', {
        currency_id
      })
        .then(response => {
          if (response.length > 0) {
            this.account = response;
            if (this.showdata.account_id != 0) {
              this.form.account_id = this.showdata.account_id;
            }
            // this.form.account_id = response[0]['id'];
          } else {
            this.account = [];
          }
        }).catch(error => {
          console.log(error);
        });
    },
    formsubmit (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let data = this.form;

          if (data.money == '' || isNaN(data.money)) {
            this.$message({
              message: '請填寫正確的交易金額',
              type: 'error'
            });
            return false;
          }

          if (data.account_id == '') {
            this.$message({
              message: '請選擇交易賬號',
              type: 'error'
            });
            return false;
          }


          if (data.business_type == -1) {
            this.$message({
              message: '請選擇交易類型',
              type: 'error'
            });
            return false;
          }


          // console.log(data);
          // return false;
          this.loading = true;
          let mso_id = sessionStorage.getItem('mso_id');
          data.mso_id = mso_id;
          data.staff_id = sessionStorage.getItem('staff_id');
          this.post('/api/business/edit', data).then((res) => {
            if (res.status == 'success') {
              this.$message({
                showClose: true,
                message: '修改成功',
                type: 'success',
                onClose: (() => {
                  this.loading = false;
                })
              });
              this.$emit('update:visible', false);
              this.$emit('submit', {});
            } else if (res.status == 'cash') {
              this.$message({
                showClose: true,
                message: '同一訂單的關聯單，買入和賣出貨幣不能同時為現金！',
                type: 'error'
              });
              this.loading = false
            } else {
              this.$message({
                showClose: true,
                message: '修改失敗',
                type: 'error'
              });
              this.loading = false
            };
          }).catch((err) => {
            this.loading = false;
            console.log(err)
          });
        }
      });
    },
    getstore () {
      let mso_id = sessionStorage.getItem('mso_id');
      this.storelist = [];
      this.post('/api/order/getstore', {
        mso_id
      }).then(response => {
        if (response.length > 0) {
          this.storelist = response;
        }
      }).catch(error => {
        console.log(error);
      }).then(() => {
        this.getcurrency();
      });
    },
    getsector () {
      let mso_id = sessionStorage.getItem('mso_id');
      let staff_id = sessionStorage.getItem('staff_id');
      this.post('/api/sector/usersector', {
        mso_id,
        staff_id,
      }).then(response => {
        if (response.length > 0) {
          this.sectorlist = response;
        }
      }).catch(error => { });
    },
  },
  created () {
    this.getsector();
    this.getstore();
    // 过滤表格配置传递的参数，如果存在则替换默认值，否则按默认值显示
    for (let key in this.showdata) {
      if (this.form.hasOwnProperty(key)) { //把默认配置中的配置项进行替换
        this.form[key] = this.showdata[key];
      }
    }

    this.showdata.files.map((v) => {
      let file = {
        name: '',
        fileurl: v.fileurl,
        url: v.fileurl
      }
      this.form.file_list.push(file);
    })

    for (let key in this.showdata.remittance) {
      if (this.form.payee.hasOwnProperty(key)) { //把默认配置中的配置项进行替换
        this.form.payee[key] = this.showdata.remittance[key];
      }

    }
  },
  watch: {
    'form.type' (val) {
      if (!this.isinit) {
        this.form.business_type = -1;
        this.form.mode = 0;
      } else {
        this.isinit = false;
      }
    },
    'form.money' (val) {
      let type3 = this.form.type3;
      if (type3 == 0) {
        this.form.hkd = getFloat(val * this.form.rate);
      } else {
        this.form.hkd = getFloat(val / this.form.rate);
      }
    },
    'form.rate' (val) {
      let type3 = this.form.type3;
      if (type3 == 0) {
        this.form.hkd = getFloat(this.form.money * val);
      } else {
        this.form.hkd = getFloat(this.form.money / val);
      }
    },
    'form.currency_id'(val){
      if(val==2){
        this.form.area = 0;
      }else if(val==1){
        this.form.area = 1;
      }else{
        this.form.area = 2;
      }
    },
    'form': { // 動態表單變化
      handler: function (newVal, oldVal) {
        // console.log('監控information組件');
        // console.log(newVal);
      },
      deep: true
    },
  }

};
</script>
<style scoped>
.mm-row {
  width: 50%;
}

.boxhader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
}
.mm-flex-item {
  margin-right: 10px;
}
.mm-flex {
  display: flex;
}
.box-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.box-left > div {
  margin-right: 20px;
}

.changeorderstatus {
  display: flex;
  align-items: center;
}

.box {
  border-radius: 4px;
  border: 1px solid #ebeef5;
  min-height: 200px;
  padding: 0 20px;
}
.mm-item {
  display: block;
  flex: 1;
  align-items: center;
}
.mm-row {
  margin: 20px 0;
}

.box-group {
  padding: 20px;
}

.backgroup {
  background: #fafafa;

  border: 1px solid #ebeef5;
  border-radius: 4px;
  min-height: 200px;
}
.el-form-item {
  margin: 0;
}
.mr15 {
  margin-right: 15px;
}

@media screen and (max-width: 1024px) {
  .jyfs {
    display: flex;
    justify-content: space-between;
    flex: 1 1 100%;
  }
  .box-group {
    padding: 0;
  }
  .mm-item {
    display: block;
  }
  .mm-flex {
    display: block;
  }
  .mm-flex.phoneflex {
    display: flex;
  }
  .mm-flex-item {
    margin: 10px 0;
    margin-right: 10px;
  }
  .mm-row {
    margin: 0;
  }
}
</style>
